<app-nav></app-nav>
<div class="container mt-2 mb-2 pt-5 pb-5">
    <div class="row ">
        <div class="col-5 border-right border-dark">
            <h1>Your Personal <br>AI Companion</h1>
            <p>If you're feeling off, overwhelmed, or just want to understand your mind better — Anima is here to
                help.</p>
            <ul class="features">
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Take science-based tests for stress, burnout, and mood
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Chat with an AI trained in mental health
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Analyze your state with real-time eye-tracking
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Detect early signs of emotional strain before they escalate
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    See how attention patterns reflect your mental load
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Get personalized, evidence-based recommendations
                </li>
                <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Stay fully private
                </li>
            </ul>
        </div>
        <div class="col-7 pt-4 pb-4 d-flex justify-content-end">
            <div class="pricing-wrapper">
                <h3 class="mb-4">Start Your Journey with Anima</h3>
                <div class="border border-primary pt-4 pb-4 pl-3 pr-3 mb-4">
                    <div class="d-flex justify-content-between align-items-center w-100 mb-3">
                        <h3 class="">AI Companion Access</h3>
                        <h3 class="highlight">$0</h3>
                    </div>
                    <p class="text-primary">
                        Anima helps you understand your mental state in just minutes with personalized support from an
                        AI companion trained in neuroscience. You'll get daily insights to manage stress, anxiety, and
                        focus — plus access to advanced tests for burnout, depression, and emotional overload.
                    </p>
                </div>
                <hr class="border-dark">
                <div class="d-flex justify-content-between align-items-center mt-4 mb-3">
                    <h3 class="">
                        Start Your Free Trial
                    </h3>
                    <div class="custom-switch-control d-flex justify-content-between align-items-center"
                         *ngIf="items.length">
                        <button [disabled]="payPalLoading" class="btn btn-sm p-1 toggle-button"
                                [ngClass]="{'highlight': activePlan.id === items[0].id}"
                                (click)="switchPlan(items[0])">{{items[0].frequency === 'monthly' ? 'monthly' : 'yearly'}}</button>
                        <i (click)="switchPlan(items[1])" *ngIf="activePlan.id === items[0].id"
                           class="toggle highlight bi bi-toggle-off"></i>
                        <i (click)="switchPlan(items[0])" *ngIf="activePlan.id === items[1].id"
                           class="toggle highlight bi bi-toggle-on"></i>
                        <button [disabled]="payPalLoading" class="btn btn-sm p-1 toggle-button"
                                [ngClass]="{'highlight': activePlan.id === items[1].id}"
                                (click)="switchPlan(items[1])">{{items[1].frequency === 'monthly' ? 'monthly' : 'yearly'}}</button>
                    </div>
                </div>

                <div class="prices mb-5">
                    <ng-container *ngFor="let item of items; let i=index">
                        <div class="price-item" *ngIf="activePlan.id === items[i].id">
                            <div class="value-wrapper"><span class="currency">$</span><span
                                    class="value">{{item.value}}</span><span
                                    class="period">/month</span></div>
                            <p>{{item.title}}</p>
                        </div>
                    </ng-container>
                    <div class="free_trial_placeholder">
                        7-day Free Trial
                    </div>
                </div>
                <div class="mt-5 order_details">
                    <h3 class="mb-3">Order Details</h3>
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            Anima AI Companion<br>
                            Neuroscientific Tracker for anxiety, stress, burnout, and depression<br>
                            Personal Recommendations and Insights
                        </div>
                        <b class="pl-4">$0</b>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between align-items-center">
                        <div></div>
                        <span>Total: <b>$0</b></span>
                    </div>
                </div>
                <div class="w-100 mt-4" [id]="'paypal-button-container'"></div>

                <ngx-paypal *ngIf="isLoggedIn" class="w-100"
                            [config]="payPalConfig"></ngx-paypal>
                <ng-container *ngIf="!isLoggedIn" >
                   <button (click)="login()" class="btn btn-block btn-link  text-center justify-content-center"> Please login to proceed payment</button>
                </ng-container>
                <div class="powered-by mt-2 text-center">
                    <span>Powered by</span><img src="assets/img/paypal.png" alt="paypal-icon"/>
                </div>
                <ng-container *ngIf="paymentError">
                    <div>
                        <h5>
                            Oops!
                        </h5>
                        <p>
                            It looks like something went wrong with your payment. No worries – just double-check your
                            details or try a
                            different payment method. Need a hand? We're here to help <a email="'support@anima.help'">support@anima.help</a>!
                        </p>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
<lib-preloader [text]="'checking the payment status...'" [loading]="loading"></lib-preloader>
